module.exports = __webpack_public_path__ + "static/tri_flower_frond-115c8273abf0c3fcb118a00829e4a7e1.png";